import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route, extract } from '@app/core';
import {ShoppingPromotionsComponent} from '../shopping-promotions/shopping-promotions.component';
import {ShoppingCuponsComponent} from '@app/shopping-cupons/shopping-cupons.component';
import {ShoppingScratchesComponent} from '@app/shopping-scratches/shopping-scratches.component';
import {LoginPageComponent} from '@app/login-page/login-page.component';
import {ShoppingVouchersComponent} from '@app/shopping-vouchers/shopping-vouchers.component';

const routes: Routes = Route.withShellPublic([
  {
    path: 'shopping/:shoppingId/promotions', component: ShoppingPromotionsComponent, data: {
      title: extract('Promoções')
    }
  },
  {
    path: 'shopping/:shoppingId/cupons', component: ShoppingCuponsComponent, data: {
      title: extract('Cupons eletrônicos')
    }
  },
  {
    path: 'shopping/:shoppingId/scratches', component: ShoppingScratchesComponent, data: {
      title: extract('Cupons raspáveis digitais')
    }
  },
  {
    path: 'shopping/:shoppingId/vouchers', component: ShoppingVouchersComponent, data: {
      title: extract('Vouchers de prêmios instantâneos')
    }
  },
  {
      path: 'shopping/:shoppingName', component: LoginPageComponent
  }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ShoppingRoutingModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping/shopping-routing.module.ts